import { render, staticRenderFns } from "./recovery_password_page.vue?vue&type=template&id=1aabd1bf"
import script from "./recovery_password_page.vue?vue&type=script&lang=js"
export * from "./recovery_password_page.vue?vue&type=script&lang=js"
import style0 from "./recovery_password_page.vue?vue&type=style&index=0&id=1aabd1bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports